<template>
  <div class="search_panel">
    <div class="search_top">
      <div class="search_type" :class="saerchIndex == t ? 'active' : ''" v-for="(item,t) in searchType" :key="t"
        @click="saerchIndex = t; changeType(item)">查{{ item.label }}</div>
    </div>
    <div class="search_input">
      <el-input :placeholder="searchTips" v-model="searchParam.keyword" clearable @change="search()">
        <template slot="append">
          <div @click="search()"><i class="el-icon-search"></i>&nbsp;搜索一下</div>
        </template>
      </el-input>
    </div>
    <div class="search_result_warp" ref="searchResultWarp" v-if="showResult">
      <div class="result_list" v-if="totalCount > 0">
        <div class="list_item" v-for="(item, t) in searchResult" :key="t">
          <div class="item_text" v-html="item.text" @click="showResult = false; toDetail(item)"></div>
        </div>
      </div>
      <div v-else class="result_page">暂无数据</div>
      <div v-if="searchParam.pageIndex * searchParam.pageSize < totalCount" class="result_page"
        @click="searchParam.pageIndex++; search(false)"><i class="el-icon-arrow-down"></i>&nbsp;查看更多结果</div>
    </div>
  </div>
</template>

<script>
import {
  getMedmiddleMapSearch,
  getTerminalMapSearch,
  getChannelMapSearch,
  setBaseInfo,
} from '@/api/portrait.js'
export default {
  components: {
  },
  data() {
    return {
      searchType: [
        { label: '服务人员', value: '1' },
        { label: '终端', value: '2' },
        { label: '渠道', value: '3' },
        // { label: '关系', value: '4' },
      ],
      saerchIndex: 0,
      searchTips: '搜索服务人员名称',
      searchParam: {
        pageSize: 20,
        pageIndex: 1,
        keyword: ''
      },
      showResult: false,
      searchResult: [],
      totalCount: 0
    };
  },
  created() {
    this.$emit('setType', { type: '1', code: '' })
  },
  mounted() {
    document.addEventListener('click', this.hideDom)
  },
  methods: {
    hideDom(event) {
      let dom = this.$refs.searchResultWarp
      if (dom && !dom.contains(event.target))
        this.showResult = false
    },
    changeType(row) {
      this.searchParam.keyword = ''
      this.$emit('setType', { type: row.value, code: '' })
      if (row.value == '1') {
        this.searchTips = '搜索服务人员名称'
      } else if (row.value == '2') {
        this.searchTips = '搜索终端名称'
      } else if (row.value == '3') {
        this.searchTips = '搜索渠道名称'
      } else if (row.value == '4') {
        let queryInfo = this.$route.query
        queryInfo.type = row.value
        queryInfo.data = row
        this.$router.push({ path: '/portrait/relativeNetwork', query: queryInfo })
      }
    },
    search(init) {
      if (this.searchParam.keyword == '') return
      let isInit = init == undefined ? true : init
      if (isInit) {
        this.searchParam.pageIndex = 1;
        this.totalCount = 0;
      }
      let params = JSON.parse(JSON.stringify(this.searchParam))
      let method = null
      if (this.saerchIndex == 0) {
        method = getMedmiddleMapSearch(params)
      } else if (this.saerchIndex == 1) {
        method = getTerminalMapSearch(params)
      } else if (this.saerchIndex == 2) {
        method = getChannelMapSearch(params)
      }
      method.then(res => {
        let data = res.data.records ? res.data.records : []
        //使用正则处理关键字高亮显示
        let reg = new RegExp(this.searchParam.keyword, "g");
        if (data.length > 0) {
          data = data.map(item => {
            let hText = item.name.replace(reg, (match) => {
              return `<span class="text_h">${match}</span>`
            });
            item.text = hText
            return item;
          });
        }
        if (isInit) {
          this.searchResult = data;
          this.totalCount = res.data.totalRows
        } else {
          this.searchResult = [...this.searchResult, ...data]
        }
        this.showResult = true
      })
    },
    toDetail(row) {
      this.searchParam.keyword = row.name
      let type = this.saerchIndex + 1
      row.level = 3
      row.type = type
      row = setBaseInfo(row, type)
      let info = {
        id: row.idCard || row.damId,
        level: row.level || 3,
        type: type,
        code: row.code,
        toPosit: true
      }
      this.$emit('getRelated', info, row)
    }
  }
};
</script> 
<style lang="less" scoped>
.search_panel {
  position: absolute;
  left: .5rem;
}

.search_top {
  display: flex;
  font-size: 12px;
  color: #212121;
  user-select: none;

  .search_type {
    width: 96px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    background: #FAFAFA;
    border: 1px solid #e6e6e6;
    cursor: default;

    &.active {
      background: #4FA1A4;
      color: #fff;
      border-color: #4FA1A4;
    }

    &:hover {
      border-color: #4FA1A4;
    }
  }
}

.search_input {
  width: 412px;

  /deep/.el-input {
    .el-input-group__append {
      width: 92px;
      padding: 0;
      background: #4FA1A4;
      color: #fff;
      font-size: 14px;
      border-color: #4FA1A4;
      border-radius: 0 2px 2px 0;
      user-select: none;
    }
  }
}

.search_result_warp {
  width: 318px;
  background: #fff;
  font-size: 14px;
  color: #212121;
  border: 1px solid #d9d9d9;

  .result_list {
    max-height: 40vh;
    overflow: hidden auto;
  }

  .list_item {
    /deep/.item_text {
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 10px;
      line-height: 40px;
      cursor: pointer;

      .text_h {
        color: #4fa1a4;
      }

      &:hover {
        background: #4FA1A4;
        color: #fff;

        .text_h {
          color: #fff;
        }
      }
    }

  }

  .result_page {
    line-height: 40px;
    font-size: 12px;
    color: #666;
    cursor: pointer;
  }
}
</style>